/**
 * BriqueChart에서 사용할 Plotly Layout의 Default
 *  - Layout 속성은 Chart Element의 briqueChartData.layoutOriginal 저장된다.
 *  - Layout 속성을 개별 화면별로 다르게 설정하려면 newPlot() 호출시 oLayout을 지정하여 호출하면 된다.
 */

import BriqueChart from './BriqueChart.vue'

export default {
  /**
   * Plotly Layout의 Default
   * 호출하는 곳의 설정이 먼저 적용된다.
   */
  defaultLayout: {
    margin: {
      t: 20, // Plotly Default : 100, Title이 있으면 100으로 설정
      r: 0, // Plotly Default : 80
      b: 0, // Plotly Default : 80
      l: 0 // Plotly Default : 80
    },
    xaxis: {
      automargin: true,
      showline: true,
      linewidth: 1,
      tickangle: 0,
      zeroline: false,
      rangeslider: undefined// Range Slider 안보이게
    },
    yaxis: {
      automargin: true, // Label이 길때 짤리는 현상 수정
      showline: true,
      lineWidth: 1, // 1만 적용된다, 2이상은 적용안됨(버그 같음)
      zeroline: false
    },
    yaxis2: {
      automargin: true, // Label이 길때 짤리는 현상 수정
      showline: true,
      lineWidth: 1, // 1만 적용된다, 2이상은 적용안됨(버그 같음)
      zeroline: false,
      overlaying: 'y',
      side: 'right'
    },
    // barmode: 'group',
    bargap: undefined, // bar 개수가 10개 미만이면 계산에 의해 설정한다.
    hoverlabel: {
      namelength: -1 // Plotly Default : 15
    }
  },

  /**
   * Layout 초기화
   * @param {Object} element 차트 Element
   * @param {Object} defaultLayout 호출하는 측에서 설정하지 않아도 적용할 기본 Layout
   * @param {Object} oLayout 호출하는 측의 Layout
   * @param {Object} briqueChartOption BriqueChart 옵션
   * @returns
   */
  initLayout (element, oLayout, defaultLayout, briqueChartOption) {
    let layout = _.merge({}, defaultLayout, oLayout)
    layout.margin.t = oLayout.margin?.t ?? (layout.title ? 100 : 20) // 20(타이틀이 있으면 100)

    BriqueChart.applyPaletteToLayout(element, layout, briqueChartOption.palette.name, false)

    return layout
  }
}
